export var ROUTE_VIEW_OFFER = 'ROUTE_VIEW_OFFER';
export var ROUTE_HOME = 'ROUTE_HOME';
export var ROUTE_BACK = 'ROUTE_BACK';
